/* @refresh reload */
import { render } from "solid-js/web";
import App from "./App";
import { loadPublicConfig } from "./lib/config";
import { initializeTheme } from "./lib/theme";
import "./style.css";

const root = document.getElementById("root");
if (!root) throw new Error("Élément racine introuvable");

initializeTheme();

loadPublicConfig()
  .then((config) => render(() => <App config={config} />, root))
  .catch((error: unknown) => {
    const message = error instanceof Error ? error.message : "Configuration indisponible";
    render(() => <main class="fatal-config"><h1>Kitae Transfer</h1><p>{message}</p><small>Le frontend statique reste accessible, mais le service de signalisation doit être configuré.</small></main>, root);
  });
